import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../store/slices/authSlice';
import { loginUser } from '../services/api';
import { APP_VERSION } from '../config/buildInfo';
import { useBrand } from '../context/BrandContext';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { brand, assets } = useBrand();

  const handleInputChange = (e) => {
    setErrorMessage('');
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      const response = await loginUser(formData);
      const { data } = response;
      dispatch(login(data));
      window.history.replaceState(null, '', '/dashboard');
      navigate('/dashboard', { replace: true });
    } catch (error) {
      console.log(error);
      setErrorMessage(error.response?.data?.error || 'Invalid login credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <section className="login-visual" style={{ backgroundImage: `url('${assets.heroUrl}')` }}>
        <div className="login-brand">
          <img src={assets.logoUrl} alt={brand.productName} />
          <span>v{APP_VERSION}</span>
        </div>
        <div className="login-visual-copy">
          <h1>{brand.productName}</h1>
          <p>Continue to manage occurrence variance reports, action plans, and registry records.</p>
          <div className="login-visual-points">
            <span><i className="bi bi-shield-check" aria-hidden="true"></i> Secure workflow</span>
            <span><i className="bi bi-clipboard2-check" aria-hidden="true"></i> {brand.taglineShort || 'OVR registry'}</span>
          </div>
        </div>
      </section>

      <section className="login-panel-wrap">
        <div className="login-panel">
          <div className="login-panel-header">
            <img src={assets.logoUrl} alt={brand.productName} />
            <div>
              <h2>Sign in</h2>
              <p>Use your registered account to continue.</p>
            </div>
          </div>

          {errorMessage && (
            <div className="login-error">
              <i className="bi bi-exclamation-circle" aria-hidden="true"></i>
              {errorMessage}
            </div>
          )}

        <form onSubmit={handleSubmit}>
          <label className="login-field">
            <span>Email</span>
            <div className="login-input-wrap">
              <i className="bi bi-envelope" aria-hidden="true"></i>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                autoComplete="username"
              />
            </div>
          </label>

          <label className="login-field">
            <span>Password</span>
            <div className="login-input-wrap">
              <i className="bi bi-lock" aria-hidden="true"></i>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-password-toggle"
                onClick={() => setShowPassword((value) => !value)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true"></i>
              </button>
            </div>
          </label>

          <button type="submit" className="login-submit-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        </div>
      </section>
    </div>
  );
};

export default Login;
